<template>
    <div class="login">
        <div class="box">
            <div class="left">
                <img src="../assets/img/logo2.png"/>
                <div>{{mingcheng.dlwz}}</div>
                <div>{{mingcheng.wz}}</div>
                <!-- <div>{{token}}</div> -->
            </div>
            <div class="right">
                <div class="item">
                    <img src="../assets/img/login-user.png"/>
                    <input v-model='user' type="text" placeholder="请输入账号"/>
                </div>
                <div class="item">
                    <img src="../assets/img/login-pwd.png"/>
                    <input v-model='pwd' type="password" placeholder="请输入密码"/>
                </div>

                <div class="btm">
                    <div class="rleft" @click="save = !save" >
                        <div class="checkbox" :class="(save ? 'check' : '')" />记住密码
                    </div>
                    <div class="rright" @click='youke()'>
                        <img src="../assets/img/login-youke.png"/>
                        游客登录
                    </div>
                </div>
                <div class="btn" @click="login()">登 录</div>
            </div>
        </div>
        <div style="text-align:center;position:absolute;width:100%;left:0;bottom:6vh;" v-if="beian != ''">
            <a href='https://beian.miit.gov.cn/' target="_blank" style="color:#fff; text-decoration:none">{{ beian }} | 中研智业集团股份有限公司Copyright©2020</a>
            
        </div>
    </div>
</template>

<script>
export default {
    name: "Login",
    data() {
        return {
            user:'',//'15245089544',
            pwd:'',//'123456',
            save: false,
            beian:''
        };
    },
    mounted() {
        this.$post('/api/ba').then(res=>{
            // console.log(res);
            this.beian = res.data;
        })
    },
    methods: {
        async login(){
            if(this.user.length == 0){
                this.$alert('请输入用户名'); return;
            }else if(this.pwd.length == 0){
                this.$alert('请输入密码'); return;
            }
            // console.log(this.isLogin());
            let res = await this.$post('/api/login',{
                mobile: this.user,
                password: this.pwd
            });

            this.$store.commit('SET', {token: res.token});
            // localStorage.setItem('token', (this.save) ? res.token : '');
            localStorage.setItem('token', res.token);
            console.log(localStorage.getItem('token'));
            // return false;

            let res1 =  await this.$post('/api/my_info',{
                token: res.token
            });
            this.$store.commit('SET', {userInfo: res1.data});
            
            this.$router.push('/home');

        },
        youke(){
            this.$router.push('/home');
        }
    }
};
</script>


<style lang="scss" scoped>
.login{
    height:100vh;
    width:100%;
    background:url(../assets/img/loginbg.png) no-repeat;
    // background-size:100% 100%;
    background-size:cover;
    background-repeat: no-repeat;
    background-position: center;
    display:flex;
    justify-content: space-around;
    align-items:center;
    .box{
        height:680px;
        width:1200px;
        // background: #000;
        .left{
            width:580px;
            height:100%;
            float:left;
            background: url(../assets/img/loginleft.png) no-repeat;
            background-size:100% 100%;
            padding:206px 96px 0;
           
            img{
                width:340px;
            }
            div{
                color:#fff;
                &:nth-child(2){
                    font-size:36px;
                    line-height:36px;
                    margin-top:40px;
                }
                &:nth-child(3){
                    font-size:40px;
                    line-height:40px;
                    margin-top:25px;
                }
            }
        }
        .right{
            width:620px;
            height:100%;
            float:right;
            background: #fff;
            padding:100px 60px 0;
            .item{
                width:100%;
                padding:60px 0 20px;
                border-bottom:solid 1px #E6E6E6;
                padding-left:44px;
                position: relative;
                img{
                    position: absolute;
                    top:60px;
                    left:0;
                    height:24px;
                }
                input{
                    border:0;
                    font-size:22px;
                    height:24px;
                    
                    
                    width:100%;
                    &::placeholder{
                        color:#999;
                    }
                }
            }
            .btm{
                margin-top:42px;
                height:30px;
                .rleft{
                    float:left;
                    color:#999;
                    font-size:16px;
                    cursor:pointer;
                    .checkbox{
                        height:20px;
                        width:20px;
                        background: #999;
                        border-radius: 4px;
                        position: relative;
                        display:inline-block;
                        // float:left;
                        margin-right:10px;
                        bottom:-4px;
                        &.check{
                            background: #2A97FE;
                            &::before{
                                content: '';
                                position: absolute;
                                width: 11px;
                                height: 5px;
                                background: transparent;
                                top: 5px;
                                left: 4px;
                                border: 2px solid white;
                                border-top: none;
                                border-right: none;
                                
                                -webkit-transform: rotate(-45deg);
                                -moz-transform: rotate(-45deg);
                                /*-o-transform: rotate(-45deg);*/
                                -ms-transform: rotate(-45deg);
                                transform: rotate(-45deg);
                            }
                        }
                    }
                    
                }
                .rright{
                    cursor: pointer;
                    float:right;
                    color:#999;
                    img{
                        position: relative;
                        bottom:-4px;
                        margin-right:10px;
                    }
                }
            }
            .btn{
                margin-top:70px;
                height:80px;
                line-height:80px;
                border-radius:100px;
                color:#fff;
                background: #0956A6;
                font-size:28px;
                text-align: center;
                cursor: pointer;
            }
        }
    }
}

</style>



// WEBPACK FOOTER //
// src/pages/Login.vue